import { writable } from 'svelte/store'

export default writable(null)
